import store from '../../store';

export default async (to, from, next) => {
    if (process.env.VUE_ENV === 'development')
        console.log(to.name.split('-')[0]);
    if (store.getters['authenticated']) {
        if (store.getters['authenticated'] && store.getters['permissions'].includes('viewAny ' + to.name.split('-')[0])) {
            next();
        } else {
            let path = to.fullPath.split('/')[2] ? to.fullPath.split('/')[2] : to.fullPath.split('/')[1];
            await store.dispatch('setErrorModal', true);
            await store.dispatch('setErrorMessage', `You don\'t have permission.... to view ${path}`);
            next({path: from.path});
        }
    } else {
        next({name: 'login-page'});
    }
}